import { render, staticRenderFns } from "./RoleCreateModal.vue?vue&type=template&id=7d005f06&"
import script from "./RoleCreateModal.vue?vue&type=script&lang=js&"
export * from "./RoleCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports